import { useState, useEffect, useCallback } from 'react';
import firmService from '../services/firmService';

export function useFirms() {
    const [firms, setFirms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchFirms = useCallback(async () => {
        // Only fetch if authenticated
        const token = localStorage.getItem('authToken');
        if (!token) {
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            setError(null);
            const data = await firmService.getAllFirms();
            setFirms(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchFirms();
    }, [fetchFirms]);

    const createFirm = async (firmData) => {
        try {
            const newFirm = await firmService.createFirm(firmData);
            setFirms(prev => [...prev, newFirm]);
            return newFirm;
        } catch (err) {
            throw err;
        }
    };

    const updateFirm = async (id, firmData) => {
        try {
            const updatedFirm = await firmService.updateFirm(id, firmData);
            setFirms(prev => prev.map(f => f.id === id ? updatedFirm : f));
            return updatedFirm;
        } catch (err) {
            throw err;
        }
    };

    const deleteFirm = async (id) => {
        try {
            await firmService.deleteFirm(id);
            setFirms(prev => prev.filter(f => f.id !== id));
        } catch (err) {
            throw err;
        }
    };

    return {
        firms,
        loading,
        error,
        createFirm,
        updateFirm,
        deleteFirm,
        refetch: fetchFirms,
    };
}